import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/flip";
import Utils from "./utils";
import { Options } from "./options";

const Header = (() => {

    let headerEl, navWrapper, navContainer, logo, isStaticPage, headerOffset;

    const initialize = (headerNode) => {

        if (!headerNode) {
            console.warn("Header.initialize: no header node provided");
            return;
        }

        headerEl = headerNode;
        setupStickyHeader();

        isStaticPage = document.body.classList.contains('static-page');

        // perform fixes for static pages
        if (isStaticPage) {

            fixTopPaddingIssue();
            // register resize handler to recalculate padding on viewport resize
            const resizeHandler = Utils.debounce(fixTopPaddingIssue, 100);
            window.addEventListener('resize', resizeHandler);
        }
    };

    /**
     * 
     * requirements:
     * - stick when scrolling down and unstick when scrolling up
     * - shrink height
     * - transparent to solid background
     */
    const setupStickyHeader = () => {

        gsap.registerPlugin(ScrollTrigger, Flip);

        navWrapper = headerEl.querySelector(".navigation-wrapper");
        navContainer = headerEl.querySelector(".nav-container");
        logo = document.querySelector(".navbar-brand img");

        headerOffset = getCurrentHeight();


        // handle animations differently according to the media breakpoints
        let mm = gsap.matchMedia();

        // for desktop 
        mm.add("(min-width: 1200px)", () => {


            ScrollTrigger.create({
                id: 'header',
                /* trigger: navWrapper, */
                trigger: 'headerEl',
                start: `top+=${headerOffset} top`,
                /* invalidateOnRefresh: true, */
                onEnter: () => {
                    activateSticky(true);
                    scheduleRefresh()
                },
                onLeaveBack: () => {
                    deactivateSticky(true);
                    scheduleRefresh()

                },
                markers: Options.animations.markers
            });
        });
        // < desktop
        mm.add("(max-width: 1199px)", () => {

            ScrollTrigger.create({
                id: 'header',
                trigger: headerEl,
                start: "top top",
                onEnter: () => activateSticky(false),
                onLeaveBack: () => deactivateSticky(false),
                /* markers: true */
            });
        });

    }

    

    /**
         * 
         * @param {boolean} isDesktop 
         */
    const activateSticky = (isDesktop) => {

        headerEl.classList.add("sticky");
        headerEl.offsetHeight; // force reflow

        if (isDesktop) {

            revealHeaderAnimation();

        } else {
            gsap.to(logo,
                { autoAlpha: 1 },
            );
        }

    }

    const deactivateSticky = (isDesktop) => {

        if (!isDesktop) return;

        headerEl.classList.remove("sticky");
        headerEl.offsetHeight; // force reflow

        revealHeaderAnimation();

    }

    const revealHeaderAnimation = () => {

        const timeline = gsap.timeline()
            .fromTo(navWrapper,
                { autoAlpha: 0 },
                { autoAlpha: 1, duration: 0.3, ease: "power2.inOut" }
            )
            
            // smooth fade-in for logo
            .fromTo(logo,
                { autoAlpha: 0 },
                { autoAlpha: 1, duration: 0.3, ease: "power2.inOut" },
                "<"
            );

            return timeline;
    }

    /**
     * fix top padding issue on static pages eg. privacy (where no hero-slider or not the first element)
     * otherwise the content is overlapped by the absolute positioned header
     */
    const fixTopPaddingIssue = () => {

        document.body.style.paddingTop = `${headerOffset}px`;
        console.debug('top padding fixed to ', headerOffset);
    };

    const getCurrentHeight = () => {

        /* const height = headerEl.offsetHeight; */

        const height = headerEl.getBoundingClientRect().height;

        /* console.debug(`Header offset: ${height}`); */
        return height;

    }

    let refreshTimeout;
    const scheduleRefresh = () => {
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(() => {
            ScrollTrigger.refresh();
        }, 100);
    }

    return {
        initialize,
        getCurrentHeight
    }
})();



export default Header;